<template>
  <div class="entry-exit-invoicing">
    <div class="entry-exit-invoicing-search">
      <div class="screen">
        <el-select class="white w200" clearable filterable v-model="screen.projectId" placeholder="请选择项目">
          <el-option
            v-for="item in projectList.filter(data => data.status)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select class="white w200" clearable v-model="screen.status" placeholder="请选择状态">
          <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-input class="white w240" v-model="screen.id" placeholder="请输入发票编号"></el-input>
        <el-input class="white w200" v-model="screen.invoiceNumber" placeholder="请输入发票号"></el-input>
        <el-input class="white w200" v-model="screen.invoicePerson" placeholder="请输入开票人"></el-input>
        <el-date-picker
          class="w240"
          v-model="screen.date"
          type="daterange"
          start-placeholder="开始推送"
          end-placeholder="结束推送"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button class="btn-blue" @click="onScreen">搜索</el-button>
      </div>
    </div>

    <DropTable
      ref="table"
      :columns="tableTitle"
      :data="tableData"
      tableKey="inventoryReconciliationList"
      border
    >
      <template slot="action" slot-scope="scope">
        <el-button class="btn-text" type="text" @click="lookDetails(scope.row.id)">详情</el-button>
        <el-button class="btn-text" type="text" @click="openInvoiceRecordsDialog(scope.row.id)">开票记录</el-button>
      </template>
    </DropTable>

    <div class="footer">
      <pagination-tpl 
        :total="total" 
        :currentPage="currentPage" 
        :pageSize="pageSize"
        :layout="layout"
        @queryChange="queryChange"
        @onSizeChange="onSizeChange"
      ></pagination-tpl>
    </div>

    <!-- 开票记录 -->
    <el-dialog title="开票记录" top="18vh" :visible.sync="invoiceRecordsDialog" width="540px">
      <div class="border"></div>
      <div class="table">
        <el-table ref="table" :data="invoiceRecords" style="width: 100%">
          <el-table-column v-for="(item, index) in invoiceRecordsTitle" :key="index" :prop="item.prop"
            :label="item.label" :width="item.width" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeInvoiceRecordsDialog">取消</el-button>
        <el-button class="btn-blue" @click="closeInvoiceRecordsDialog">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CurrencyMinxins from "common/mixins/currency";
import DropTable from "components/base/DropTable.vue";
import PaginationTpl from "components/base/PaginationTpl";
import EntryExitInvoicing from "models/entry-exit-invoicing";
import { formaTimeToMinute, modifyNetTitle } from "common/js/util";
import EntryExitInvoicingStatusMixins from "common/mixins/entry-exit-invoicing/status";
import EnterExitWarehouseProjectMixins from 'common/mixins/enter-exit-warehouse-project'
export default {
  mixins: [CurrencyMinxins, EntryExitInvoicingStatusMixins, EnterExitWarehouseProjectMixins],
  data() {
    return {
      // 1：应收 2:应付
      accountsType: 1,
      screen: {
        projectId: null,
        status: "",
        id: "",
        invoiceNumber: "",
        invoicePerson: "",
        date: ""
      },
      tableData: [],
      tableTitle: [
        { checked: true, prop: 'id', label: '发票编号', "width": 100},
        { checked: true, prop: 'projectName', label: '项目名称', "min-width": 140},
        { checked: true, prop: 'pushTime', label: '推送时间', "width": 150},
        { checked: true, prop: 'billNumbers', label: '所属账单编号', "min-width": 140},
        { checked: true, prop: 'billHeadName', label: '抬头', "min-width": 150},
        { checked: true, prop: 'currencyVal', label: '币制', "width": 110},
        { checked: true, prop: 'agentBusinessVal', label: '代收代付', "width": 100},
        { checked: true, prop: 'statusVal', label: '开票状态', "width": 110},
        { checked: true, prop: 'invoicePerson', label: '开票人', "width": 120},
        { checked: true, prop: 'invoiceNumber', label: '发票号', "width": 150},
        { checked: true, prop: 'billOriginalAmount', label: '金额', "width": 120},
        { 
          checked: true, 
          label: "操作", 
          prop: "action", 
          fixed: "right", 
          "width": "140",
          slotName: "action", // 自定义单元格插槽
        }
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      layout: 'jumper, prev, pager, next, sizes',
      invoiceRecordsDialog: false,
      invoiceRecords: [],
      invoiceRecordsTitle: [
        { prop: 'time', label: '时间', width: '150' },
        { prop: 'info', label: '信息', width: '' },
      ],
    };
  },
  components: {
    DropTable,
    PaginationTpl
  },
  created() {
    modifyNetTitle('进出仓应收开票列表')
    this.initEntryExitInvoicingList();
    this.initEnterExitWarehouseProjectData();
  },
  methods: {
    //获取进出仓开票列表
    initEntryExitInvoicingList() {
      let pageNo = this.currentPage;
      let accountsType = this.accountsType;
      let pageSize = this.pageSize;
      let status = this.screen.status?this.screen.status:0;
      let id = this.screen.id?this.screen.id:0;
      let projectId = this.screen.projectId?this.screen.projectId:0;
      let invoiceNumber = this.screen.invoiceNumber?this.screen.invoiceNumber:'';
      let invoicePerson = this.screen.invoicePerson?this.screen.invoicePerson:'';
      let beginPushTime = this.screen.date[0]?this.screen.date[0]:''
      let endPushTime = this.screen.date[1]?this.screen.date[1]:''
      let data = {
        pageNo,
        pageSize,
        accountsType,
        status,
        id,
        projectId,
        invoiceNumber,
        invoicePerson,
        beginPushTime,
        endPushTime
      }
      EntryExitInvoicing.getEntryExitInvoicingList(data).then(res => {
        if (res.success) {
          let tableData = [];
          this.pageSize = res.result.size;
          this.total = res.result.total;
          res.result.records.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.projectId = value.projectId;
            obj.projectName = value.projectName;
            obj.billNumbers = value.billNumbers;
            obj.billHeadName = value.billHeadName;
            obj.bankAccount = value.bankAccount;
            obj.bankName = value.bankName;
            obj.currency = value.currency;
            obj.currencyVal = this.currencySystemObj[value.currency];
            obj.status = value.status;
            obj.statusVal = this.statusObj[value.status];
            obj.agentBusiness = value.agentBusiness;
            obj.agentBusinessVal = value.agentBusiness ?'是':'否';
            obj.billOriginalAmount = value.billOriginalAmount;
            obj.invoicePerson = value.invoicePerson || '';
            obj.invoiceNumber = value.invoiceNumber || '';
            obj.pushTime = value.pushTime?formaTimeToMinute(value.pushTime):'';
            tableData.push(obj);
          });
          this.tableData = tableData;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @description 开票记录列表
    */
    initInvoiceRecordsList(id) {
      EntryExitInvoicing.getInvoiceRecordsList(id).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.time = value.createdTime?formaTimeToMinute(value.createdTime):'';
            obj.info = value.memo;
            arr.push(obj);
          });
          this.invoiceRecords = arr;
          this.invoiceRecordsDialog = true
        }
      });
    },

    onScreen() {
      this.currentPage = 1;
      this.initEntryExitInvoicingList();
    },
    //查看详情
    lookDetails(id) {
      let routeData = this.$router.resolve({
        path: '/finance/entry-exit-invoicing/entry-exit-invoicing-details',
        query: {
          entryExitInvoicingId: id
        }
      });
      window.open(routeData.href, '_blank');
    },
    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initEntryExitInvoicingList();
    },
    onSizeChange(data) {
      this.pageSize = data.pageSize;
      this.initEntryExitInvoicingList();
    },

    openInvoiceRecordsDialog(id) {
      this.initInvoiceRecordsList(id)
    },

    closeInvoiceRecordsDialog() {
      this.invoiceRecordsDialog = false
    }
  }
};
</script>
<style lang="scss" scoped>
.entry-exit-invoicing {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .entry-exit-invoicing-search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .screen {
      display: flex;
      flex-wrap: wrap;
      gap: 10px 0;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
      .w240 {
        width: 240px;
        margin-right: 16px;
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
  .table {
    .btn-text.is-disabled {
      color: #CCCCCC;
    }
  }
  .el-dialog {
    .el-dialog__header {
      padding-left: 20px;
    }
  
    .el-dialog__body {
      padding: 0px;
  
      .border {
        border-color: #EEEEEE;
        margin-bottom: 0px
      }
      .table {
        height: 280px;
        overflow-y: auto;
        padding: 20px 4px 0px 4px;
      }
    }
  
    .dialog-footer {
      padding-bottom: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
